<template>
  <!--Hey! This is the original version
of Simple CSS Waves-->
  <div class="aboutconfig">
    <div class="header">
      <!--Content before waves-->
      <div class="inner-header flex">
        <!--Just the logo.. Don't mind this-->
        <!-- <svg
          version="1.1"
          class="logo"
          baseProfile="tiny"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 500 500"
          xml:space="preserve"
        >
          <path
            fill="#FFFFFF"
            stroke="#000000"
            stroke-width="10"
            stroke-miterlimit="10"
            d="M57,283"
          />
          <g>
            <path
              fill="#fff"
              d="M250.4,0.8C112.7,0.8,1,112.4,1,250.2c0,137.7,111.7,249.4,249.4,249.4c137.7,0,249.4-111.7,249.4-249.4
C499.8,112.4,388.1,0.8,250.4,0.8z M383.8,326.3c-62,0-101.4-14.1-117.6-46.3c-17.1-34.1-2.3-75.4,13.2-104.1
c-22.4,3-38.4,9.2-47.8,18.3c-11.2,10.9-13.6,26.7-16.3,45c-3.1,20.8-6.6,44.4-25.3,62.4c-19.8,19.1-51.6,26.9-100.2,24.6l1.8-39.7    c35.9,1.6,59.7-2.9,70.8-13.6c8.9-8.6,11.1-22.9,13.5-39.6c6.3-42,14.8-99.4,141.4-99.4h41L333,166c-12.6,16-45.4,68.2-31.2,96.2  c9.2,18.3,41.5,25.6,91.2,24.2l1.1,39.8C390.5,326.2,387.1,326.3,383.8,326.3z"
            />
          </g>
        </svg> -->

        <svg
          id="svg"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="logo"
          width="100"
          height="100"
          viewBox="0, 0, 400,400"
        >
          <g id="svgg">
            <path
              id="path0"
              d="M185.478 21.442 C 153.498 27.723,132.430 56.840,130.971 96.775 C 128.983 151.191,154.028 181.395,201.333 181.630 C 248.296 181.864,274.974 150.547,272.983 97.521 C 270.976 44.034,234.025 11.908,185.478 21.442 M221.594 35.036 C 243.285 45.151,251.128 62.511,251.243 100.667 C 251.388 148.666,236.130 170.794,202.667 171.116 C 170.256 171.428,153.011 147.466,152.924 102.000 C 152.818 47.317,183.587 17.313,221.594 35.036 M56.000 39.925 C 56.000 41.269,63.798 63.082,133.371 256.364 L 177.897 380.062 199.775 379.698 L 221.653 379.333 254.116 290.000 C 271.971 240.867,289.557 192.567,293.197 182.667 C 296.836 172.767,309.743 137.300,321.878 103.852 C 334.013 70.405,344.325 42.039,344.794 40.817 C 345.570 38.794,343.829 38.629,325.347 38.964 L 305.048 39.333 285.062 96.000 C 257.837 173.191,227.558 259.226,213.628 298.970 C 207.272 317.103,201.698 331.503,201.241 330.970 C 200.784 330.436,197.059 320.400,192.963 308.667 C 188.867 296.933,167.232 235.433,144.885 172.000 C 122.538 108.567,102.849 52.617,101.132 47.667 L 98.009 38.667 77.004 38.667 C 64.724 38.667,56.000 39.189,56.000 39.925 M187.153 48.119 C 163.330 55.023,149.999 87.068,158.066 118.040 C 168.672 158.757,225.999 162.905,243.702 124.237 C 262.835 82.444,228.444 36.152,187.153 48.119 M218.010 57.606 C 237.428 69.940,240.884 117.870,223.600 135.129 C 203.279 155.420,175.654 142.059,170.601 109.496 C 164.438 69.769,191.142 40.540,218.010 57.606 M190.000 66.759 C 188.533 67.339,185.683 67.855,183.667 67.906 C 179.198 68.020,178.644 71.622,183.000 72.241 C 185.981 72.664,186.002 72.830,186.362 99.016 L 186.723 125.365 183.362 126.896 C 177.520 129.558,179.668 130.667,190.667 130.667 C 201.917 130.667,203.949 129.572,197.333 127.075 C 193.607 125.668,193.333 125.098,193.333 118.748 L 193.333 111.932 197.267 113.966 C 211.812 121.487,225.375 110.499,225.203 91.333 C 225.018 70.822,211.626 59.506,198.266 68.573 L 193.492 71.812 193.079 68.759 C 192.746 66.295,192.152 65.909,190.000 66.759 M213.291 72.262 C 220.278 79.761,220.692 100.411,214.023 108.775 C 209.956 113.875,201.816 114.171,196.742 109.404 C 191.400 104.385,191.523 78.702,196.916 73.073 C 201.524 68.263,209.211 67.882,213.291 72.262 M178.667 186.511 C 178.667 187.159,179.867 188.003,181.333 188.386 C 183.913 189.061,184.000 190.205,184.000 223.333 C 184.000 256.462,183.913 257.606,181.333 258.280 C 175.514 259.802,179.192 261.333,188.667 261.333 C 197.922 261.333,202.563 259.406,195.667 258.426 C 192.758 258.013,192.655 257.485,192.293 241.000 L 191.920 224.000 195.182 224.000 C 198.121 224.000,212.000 253.792,212.000 260.100 C 212.000 260.778,215.000 261.333,218.667 261.333 C 225.635 261.333,227.665 259.303,222.095 257.905 C 220.207 257.431,218.051 255.335,216.926 252.879 C 213.963 246.410,206.214 223.985,206.807 223.598 C 207.097 223.409,209.587 222.230,212.342 220.978 C 228.162 213.788,224.790 191.676,207.126 186.772 C 200.946 185.055,178.667 184.852,178.667 186.511 M207.880 191.271 C 222.441 198.801,213.971 221.333,196.580 221.333 L 192.000 221.333 192.000 205.556 C 192.000 186.481,194.415 184.308,207.880 191.271 "
              stroke="none"
              fill="#000000"
              fill-rule="evenodd"
            ></path>
            
          </g>
        </svg>
        <!-- <img style="width:10%;heigth:10%" :src="this.$store.state.boxMessage.ooplogo" alt="logo"> -->
        <h1>
          面向对象的虚拟与现实,实现可靠性的业务仿真。
          <br />
          以分享，学习，开源，简简单单达成目的为主的网站！
        </h1>
      </div>

      <!--Waves Container-->
      <div>
        <svg
          class="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g class="parallax">
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="0"
              fill="rgba(255,255,255,0.7"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="3"
              fill="rgba(255,255,255,0.5)"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="5"
              fill="rgba(255,255,255,0.3)"
            />
            <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div>
      <!--Waves end-->
    </div>
    <!--Header ends-->

    <!--Content starts-->
    <div class="content flex">
      <!-- <p>Daniel Österman | 2019 | Free to use</p> -->
    </div>
    <!--Content ends-->
  </div>
</template>
<script>
export default {
  name: "Aboutconfig",
  data() {
    return {
      name: "关于本站",
      text: "",
    };
  },

  mounted() {
    // console.log(this.$store.state.boxMessage)
  },
};
</script>
<style lang='less' scoped>
.aboutconfig {
  // @import (css)"//fonts.googleapis.com/css?family=Lato:300:400)";
  h1 {
    font-family: "Lato", sans-serif;
    font-weight: 300;
    letter-spacing: 2px;
    font-size: 28px;
  }
  p {
    font-family: "Lato", sans-serif;
    letter-spacing: 1px;
    font-size: 14px;
    color: #333333;
  }

  .header {
    position: relative;
    text-align: center;
    background: linear-gradient(
      60deg,
      rgba(84, 58, 183, 1) 0%,
      rgba(0, 172, 193, 1) 100%
    );
    color: white;
  }
  .logo {
    width: 100px;
    fill: white;
    padding-right: 15px;
    display: inline-block;
    vertical-align: middle;
  }

  .inner-header {
    height: 65vh;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .flex {
    /*Flexbox for containers*/
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .waves {
    position: relative;
    width: 100%;
    height: 15vh;
    margin-bottom: -7px; /*Fix for safari gap*/
    min-height: 100px;
    max-height: 150px;
  }

  .content {
    position: relative;
    height: 20vh;
    text-align: center;
    background-color: white;
  }

  /* Animation */

  .parallax > use {
    animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
  }
  .parallax > use:nth-child(1) {
    animation-delay: -2s;
    animation-duration: 7s;
  }
  .parallax > use:nth-child(2) {
    animation-delay: -3s;
    animation-duration: 10s;
  }
  .parallax > use:nth-child(3) {
    animation-delay: -4s;
    animation-duration: 13s;
  }
  .parallax > use:nth-child(4) {
    animation-delay: -5s;
    animation-duration: 20s;
  }
  @keyframes move-forever {
    0% {
      transform: translate3d(-90px, 0, 0);
    }
    100% {
      transform: translate3d(85px, 0, 0);
    }
  }
  /*Shrinking for mobile*/
  @media (max-width: 768px) {
    .waves {
      height: 40px;
      min-height: 40px;
    }
    .content {
      height: 30vh;
    }
    h1 {
      font-size: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bottonconfig/aboutconfig.vue